/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-loop-func */
/* eslint-disable no-await-in-loop */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unreachable */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable consistent-return */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable prefer-const */

// Upload de extratos/cálculo do valor a receber
// import axios from 'axios';
import React, { useState, useContext, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import fb from 'firebaseConfig';
import * as Sentry from '@sentry/react';
import { useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';

// Uppy
import Uppy from '@uppy/core';
import Dashboard from '@uppy/dashboard';
import Portuguese from '@uppy/locales/lib/pt_BR';
import GoogleDrive from '@uppy/google-drive';
import Tus from '@uppy/tus';
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';

import {
  Tooltip,
  IconButton,
} from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';

import { AuthContext } from 'providers/AuthProvider';

import { ALERT_TYPE } from 'components/Alert';
import { Button } from 'components/Button';
import { Text, Title } from 'components/Text';
import { LabelInput } from 'components/Input';
import SnackMessage, { OPTIONS } from 'components/SnackMessage';

import trash from 'assets/icons/trash.svg';

import PATH from 'routes/path';

import { checkCoupon, getCustomers, updateCustomer } from 'services/api/customers';
import { createEventTracking } from 'services/api/tracking';
import { checkFiles, uploadFiles } from 'services/api/extract';

import { COLOR } from 'assets/styles/colors';
import HelpModal from './HelpModal';
import EmailModal from './EmailModal';
import InputFile from './InputFile';
import {
  Container, Styles,
  LinkText, Table,
  ContainerExtract,
  ContainerButtons,
  Wrapper, Header,
  BoxInputs, InputWrapper,
} from './styles';

const {
  REACT_APP_UPPY_COMPANION,
  REACT_APP_TUS_URL,
} = process.env;

const Calculation = () => {
  const { currentUser } = useContext(AuthContext);
  const [files, setFiles] = useState([]);
  const [input, setInput] = useState(false);
  const [saved, setSaved] = useState([]);
  const [user, setUser] = useState({
    full_name: '',
    email: '',
    coupon: '',
  });
  const [errorInput, setError] = useState({});
  const [loading, setLoading] = useState({
    saveLoading: false,
    continueLoading: false,
    driveLoading: false,
  });
  const [openHelp, setOpenHelp] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const [showCoupon, setShowCoupon] = useState(false);

  const style = Styles();

  const history = useHistory();

  const location = useLocation();

  const { enqueueSnackbar } = useSnackbar();

  const { idToken } = useContext(AuthContext);

  // Cria e retorna um objeto FormData a partir dos 'files'
  const createFormDataList = (values) => {
    const formData = new FormData();

    for (let i = 0; i < values.length; i++) {
      let file = values[i];
      formData.append('upload', file);
    }
    return formData;
  };

  // Tratamento dos arquivos (Uppy/Google Drive)
  const downloadFiles = async (filesDrive) => {
    setLoading({
      ...loading,
      driveLoading: true,
    });

    let arrayFiles = [];
    for (let index = 0; index < filesDrive.length; index++) {
      await axios.get(filesDrive[index].uploadURL, {
        responseType: 'blob', // Important
      }).then((res) => {
        const file = new File([res.data], filesDrive[index].name, { type: res.data.type });
        arrayFiles.push(file);
      }).catch((error) => {
        // console.log('successful files:', error);
        console.error('Erro ao carregar os arquivos pelo Uppy.');
      });
    }
    setFiles(arrayFiles);
    setLoading({
      ...loading,
      driveLoading: false,
    });
  };

  // Carrega os dados do usuário (customer)
  const loadCustomer = async () => {
    try {
      const { data } = await getCustomers();
      setUser({
        ...data[0],
        email: currentUser.email,
        coupon: data[0].meta_data.coupon || '',
      });
    } catch (error) {
      const { response } = error;
      if (response) {
        if (response.status === 403) {
          setTimeout(() => {
            loadCustomer();
          }, 3000);
        }
      } else {
        // console.log(error);
        enqueueSnackbar('Desculpe, ocorreu um erro ao caregar os dados do usuário.', {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant="error"
            />
          ),
        });
      }
    }
  };

  useEffect(() => {
    loadCustomer();

    document.title = 'Cálculo - Revisão FGTS - LOIT';
    window.Intercom('trackEvent', 'LOIT FGTS calculo');
    createEventTracking('80 - upload');

    const { state, pathname } = location;
    // Inicialização do Uppy
    const uppy = new Uppy({
      locale: Portuguese,
      allowMultipleUploads: true,
      restrictions: {
        allowedFileTypes: ['.pdf'],
      },
      onBeforeUpload: (newFiles) => {
        const { source } = Object.entries(newFiles)[0][1];
        const tus = uppy.getPlugin('Tus');
        // adiciona ou remove plugin do Tus (apenas para arquivos do Google Drive)
        if (!tus && source === 'GoogleDrive') {
          uppy.use(Tus, {
            endpoint: REACT_APP_TUS_URL,
            resume: true,
            limit: 5,
            retryDelays: [0, 1000, 3000, 5000],
          });
        } else if (tus) {
          uppy.removePlugin(tus);
        }
      },
    })
      .use(Dashboard, {
        trigger: '#select-files',
        locale: {
          strings: {
            dropPasteImport: 'Selecione abaixo onde estão os arquivos, ou simplesmente arraste aqui...',
          },
        },
      });
    // desabilita Google Drive na Webview
    if (!localStorage.getItem('webview')) {
      uppy.use(GoogleDrive, {
        target: Dashboard,
        companionUrl: REACT_APP_UPPY_COMPANION,
      });
    }

    uppy.on('complete', (result) => {
      if (!result.successful.length) {
        enqueueSnackbar('Desculpe, ocorreu um erro ao carregar os arquivos.', {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              variant="error"
              message={message}
            />
          ),
        });
      } else if (result.successful[0].source === 'GoogleDrive') {
        downloadFiles(result.successful);
      } else {
        const formatted = result.successful.map((item) => item.data);
        setFiles(formatted);
      }

      uppy.getPlugin('Dashboard').closeModal();
      uppy.reset();
    });

    // Exibe alerta na inicializacão, casa haja
    if (state && state.alertText) {
      enqueueSnackbar(state.alertText, {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            message={message}
            variant={state.alertType}
          />
        ),
      });

      history.replace({
        pathname,
        state: {
          ...state,
          alertText: '',
          alertType: '',
        },
      });
    }
  }, []);

  const showHelp = () => {
    window.Intercom('trackEvent', 'LOIT FGTS upload ajuda');
    setOpenHelp(true);
  };

  const closeHelp = () => setOpenHelp(false);
  const closeEmail = () => setOpenEmail(false);

  // Remove item do 'saved'
  const deleteFile = (path) => {
    const arr = saved.filter((item) => item.name !== path);
    setSaved(arr);
  };

  const handleClick = async () => {
    setLoading({ saveLoading: true });
    const filter = files.filter((value) => value.type === 'application/pdf');
    const invalidFiles = files.filter((value) => value.type !== 'application/pdf');

    if (!filter.length) {
      setFiles([]);
      setLoading({ saveLoading: false });
      setInput(true);
      return (
        enqueueSnackbar('Apenas arquivos no formato PDF são válidos.', {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant="error"
            />
          ),
        })
      );
    }

    if (invalidFiles.length) {
      enqueueSnackbar('Apenas arquivos no formato PDF são válidos.', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            variant="error"
            message={message}
          />
        ),
      });
    }

    const formData = createFormDataList([...filter, ...saved]);

    try {
      const { data } = await checkFiles(formData, idToken);
      // formata o 'data' de objeto para array
      const formattedData = Object.entries(data);

      // filtra os itens com status === ok e retorna uma lista com apenas os nomes (passedFiles)
      const passedFiles = formattedData.filter((item) => item[1].status === 'ok').map((item) => item[0]);

      const notPassedFiles = formattedData.filter((item) => item[1].status !== 'ok' && item[1].status !== 'duplicated' && item[0] !== 'event' && item[0] !== 'mkt_cookies').map((item) => item[0]);

      const duplicateFiles = formattedData.filter((item) => item[1].status === 'duplicated').map((item) => item[0]);

      const oldFiles = formattedData.filter((item) => item[1].code === 4).map((item) => item[0]);

      // filtra os 'files' que estiverem na lista 'passedFiles'
      const newSaved = files.filter((item) => passedFiles.includes(item.name));

      setSaved([
        ...saved,
        ...newSaved,
      ]);

      // limpa os 'files'
      setFiles([]);

      // muda o status para mudar o texto do input
      setInput(true);

      // Arquivos duplicados
      if (duplicateFiles.length) {
        if (duplicateFiles.length > 1) {
          setFiles([]);
          enqueueSnackbar(`${duplicateFiles.join(', ')} são arquivos duplicados.`, {
            ...OPTIONS,
            content: (key, message) => (
              <SnackMessage
                id={key}
                variant="error"
                message={message}
              />
            ),
          });
        } else {
          enqueueSnackbar(`${duplicateFiles[0]} é um arquivo duplicado.`, {
            ...OPTIONS,
            content: (key, message) => (
              <SnackMessage
                id={key}
                variant="error"
                message={message}
              />
            ),
          });
        }
      }

      // Arquivos inválidos
      if (notPassedFiles.length) {
        if (notPassedFiles.length > 1) {
          setFiles([]);
          enqueueSnackbar(`${notPassedFiles.join(', ')} não são arquivos válidos.`, {
            ...OPTIONS,
            content: (key, message) => (
              <SnackMessage
                id={key}
                message={message}
                variant="error"
              />
            ),
          });
        } else {
          enqueueSnackbar(`${notPassedFiles[0]} não é um arquivo válido.`, {
            ...OPTIONS,
            content: (key, message) => (
              <SnackMessage
                id={key}
                message={message}
                variant="error"
              />
            ),
          });
        }
      }

      // Arquivos antigos anteriores a 1999
      if (oldFiles.length) {
        setFiles([]);
        enqueueSnackbar('Extratos anteriores a 1999 não são passíveis à tese da Revisão do FGTS.', {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              variant="error"
              message={message}
            />
          ),
        });
      }
    } catch (error) {
      setInput(true);
      const { response } = error;
      // retry if timeout
      if (error.message.includes('timeout')) {
        handleClick();
      } else if (response && response.status !== 401 && response.status !== 403) {
        window.Intercom('trackEvent', 'LOIT FGTS erro de upload');
        setFiles([]);
        enqueueSnackbar('Desculpe, ocorreu um erro ao verificar os extratos.', {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              variant="error"
              message={message}
            />
          ),
        });
        Sentry.captureException(new Error('upload failure'));
      } else {
        window.Intercom('trackEvent', 'LOIT FGTS erro de upload');
        setFiles([]);
        enqueueSnackbar('Desculpe, ocorreu um erro ao anexar o extrato. Verifique se o arquivo está salvo na pasta “Downloads" do seu celular e tente novamente. Arquivos salvos no seu "Drive" ou "OneDrive" não são compatíveis.', {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant="error"
            />
          ),
        });
        Sentry.captureException(new Error('upload failure'));
      }
    } finally {
      setLoading({ saveLoading: false });
    }
  };

  // Faz upload dos extratos e cria novo calculo do FGTS
  const createFgtsData = async () => {
    if (!user.full_name || !user.email) {
      enqueueSnackbar('Você precisa preencher o seu nome para continuar.', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            message={message}
            variant="error"
          />
        ),
      });
    } else if (!saved.length) {
      enqueueSnackbar('Você precisa anexar extratos para efetuar o cálculo', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            message={message}
            variant="error"
          />
        ),
      });
    } else {
      let path = PATH.RESULTS;

      const formData = createFormDataList(saved);

      formData.append('customer', user.id);

      const newUser = {
        ...user,
        meta_data: {
          ...user.meta_data,
          coupon: errorInput.coupon ? '' : user.coupon,
        },
      };

      await updateCustomer(user.id, newUser);

      setLoading({ ...loading, continueLoading: true });

      try {
        const { data } = await uploadFiles(formData, idToken);

        await createEventTracking('90 - upload completo');
        history.push({
          pathname: path.replace(':fgts', data.fgts),
          state:
          {
            homeOrigin: false,
          },
        });
      } catch (error) {
        const { response } = error;
        // retry if timeout
        if (error.message.includes('timeout')) {
          createFgtsData();
        } else if (response && response.status !== 401 && response.status !== 403) {
          enqueueSnackbar('Desculpe, ocorreu um erro ao fazer upload.', {
            ...OPTIONS,
            content: (key, message) => (
              <SnackMessage
                id={key}
                variant="error"
                message={message}
              />
            ),
          });
          Sentry.captureException(new Error('error when calculating'));
        }
      } finally {
        setLoading({ continueLoading: false });
      }
    }
  };

  const validateCoupon = async () => {
    const { coupon } = user;

    if (coupon) {
      try {
        const { data } = await checkCoupon(coupon);

        if (data.valid) {
          enqueueSnackbar('Cupom válido!', {
            ...OPTIONS,
            content: (key, message) => (
              <SnackMessage
                id={key}
                message={message}
                variant="success"
              />
            ),
          });

          if (errorInput.coupon) {
            setError({ ...errorInput, coupon: '' });
          }
        } else {
          setError({
            ...errorInput,
            coupon: data.message,
          });
        }
      } catch (err) {
        console.error(err);
      }
    } else if (errorInput.coupon) {
      setError({ ...errorInput, coupon: '' });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setUser({ ...user, [name]: value });
  };

  // Chamada para logout (Firebase)
  const logout = () => {
    if (localStorage.getItem('webview')) {
      localStorage.clear();
      localStorage.setItem('webview', 'true');
    } else {
      localStorage.clear();
    }
    fb.auth().signOut();
  };

  const handleUpdateEmail = async (params) => {
    params.ev.preventDefault();

    const payload = {
      ...user,
      full_name: user.full_name,
      email: params.newEmail,
      skipFbUpdate: false,
    };

    // console.log(payload);

    try {
      await updateCustomer(user.id, payload);
      closeEmail();
      enqueueSnackbar('E-mail atualizado com sucesso!', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            variant={ALERT_TYPE.SUCCESS}
            message={message}
          />
        ),
      });
      await getCustomers();
      logout();
    } catch (error) {
      enqueueSnackbar('Desculpe, no momento não foi possível alterar o e-mail.', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            variant={ALERT_TYPE.ERROR}
            message={message}
          />
        ),
      });
    }
  };

  return (
    <Container>
      <Wrapper>
        <Header>
          <Title secondary>Calcular valor da revisão</Title>
          {/* ICONE DE AJUDA */}
          <Tooltip title="Sobre o cálculo" arrow>
            <IconButton
              size="small"
              color="secondary"
              onClick={showHelp}
              disabled={openHelp}
            >
              Ajuda
              <HelpIcon />
            </IconButton>
          </Tooltip>
          {/* MODAL DE AJUDA */}
          {
            openHelp && (
              <HelpModal
                open={openHelp}
                onClose={closeHelp}
              />
            )
          }
          {/* MODAL PARA ATUALIZAÇÃO DE E-MAIL/TELEFONE */}
          <EmailModal
            open={openEmail}
            onClose={closeEmail}
            handleUpdate={handleUpdateEmail}
          />
        </Header>
        <BoxInputs>
          <LabelInput
            autoFocus
            type="text"
            required
            name="full_name"
            autoComplete="name"
            label="Nome completo"
            value={user.full_name}
            onChange={handleChange}
            error={errorInput.full_name}
          />
          <InputWrapper emailExists={currentUser.email} nameEmpty={!user.full_name}>
            <LabelInput
              required
              type="email"
              name="email"
              autoComplete="email"
              label="E-mail"
              value={currentUser.email ? currentUser.email : user.email}
              onChange={handleChange}
              error={errorInput.email}
            />
            {currentUser.email && (
              <p onClick={() => setOpenEmail(!!user.full_name)}>Trocar e-mail</p>
            )}
          </InputWrapper>
          {
            (!showCoupon && !user.coupon) && (
              <LinkText
                style={{ margin: '8px 0' }}
                onClick={() => setShowCoupon(true)}
              >
                Adicionar Código ou Cupom (opcional)
              </LinkText>
            )
          }
          {
            (showCoupon || user.coupon) && (
              <LabelInput
                type="text"
                name="coupon"
                label="Código ou Cupom (opcional)"
                value={user.coupon}
                onBlur={validateCoupon}
                helperText={errorInput.coupon}
                onChange={handleChange}
                error={errorInput.coupon}
              />
            )
          }
        </BoxInputs>
        <Text className={style.text}>
          Para calcular o valor da sua revisão é necessário anexar todos os seus extratos do FGTS em formato PDF no campo abaixo.
        </Text>

        <Text className={style.text}>
          <LinkText
            target="_blank"
            rel="noreferrer"
            href="https://intercom.help/tikal-tech/pt-BR/articles/4848746-loit-fgts-obtencao-dos-extratos-do-fgts-junto-a-caixa"
          >
            <strong>Clique aqui</strong>
          </LinkText>
          {' '}
          para saber como obter seus extratos
        </Text>
        <Text className={style.text}>
          <LinkText
            target="_blank"
            rel="noreferrer"
            href="https://intercom.help/tikal-tech/pt-BR/articles/5072013-loit-fgts-nao-consigo-anexar-os-extratos-o-que-fazer"
          >
            <strong>Clique aqui</strong>
          </LinkText>
          {' '}
          caso tenha dificuldade para anexar os extratos
        </Text>
        {/* Upload padrão com o Uppt (Local/GoogleDrive) */}
        <ContainerExtract>
          <InputFile
            default={false}
            originFiles={files}
            onChange={setFiles}
            status={input}
            changeStatus={setInput}
          />
          <Button
            onClick={handleClick}
            disabled={!files.length}
            className={style.button}
            loading={loading.saveLoading}
          >
            Anexar
          </Button>
        </ContainerExtract>
        {/* Link para upload nativo (input file) */}
        <label
          htmlFor="upload"
          style={{
            display: 'inline-block',
            fontSize: 14,
            cursor: 'pointer',
            margin: '10px 0',
            color: COLOR.GREEN_2,
            textDecoration: 'underline',
          }}
        >
          Clique aqui para selecionar os arquivos do seu dispositivo
        </label>
        <input
          id="upload"
          type="file"
          multiple
          style={{ display: 'none' }}
          onChange={(e) => setFiles(Array.from(e.target.files))}
        />
        {/* {
          process.env.REACT_APP_UPPY === 'true' && (
            <a
              id="select-files"
              style={{
                display: 'inline-block',
                fontSize: 12,
                cursor: 'pointer',
                margin: '10px 0',
                color: COLOR.GREEN_2,
                textDecoration: 'underline',
              }}
            >
              Anexar do Google Drive
            </a>
          )
        } */}
        {
          !!saved.length && (
            <Table>
              <thead>
                <tr>
                  <th>Nº</th>
                  <th>Nome do arquivo</th>
                  <th style={{ textAlign: 'end' }}>Excluir</th>
                </tr>
              </thead>
              <tbody>
                {
                  saved.map((file, i) => (
                    <tr key={file.name}>
                      <td>{++i}</td>
                      <td>{file.name}</td>
                      <td style={{ textAlign: 'end', paddingRight: '20px' }}>
                        <Tooltip title="Excluir arquivo" arrow>
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => deleteFile(file.name)}
                          >
                            <img src={trash} alt="icon" />
                          </IconButton>
                        </Tooltip>
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </Table>
          )
        }
        <ContainerButtons>
          <Button
            variant="contained"
            color="primary"
            onClick={createFgtsData}
            loading={loading.continueLoading}
          >
            Calcular
          </Button>
          <Button
            variant="outlined"
            className="unset"
            onClick={() => history.push(PATH.HOME)}
          >
            Voltar
          </Button>
        </ContainerButtons>
      </Wrapper>
    </Container>
  );
};

export default Calculation;
